import React from 'react';
import styled, { ThemeProps } from 'styled-components';
import { CornerRadius } from 'styleguide/spacing';
import { Theme } from 'styleguide/types';

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const StyledImage = styled.img`
  display: block;
  aspect-ratio: attr(width) / attr(height);
  object-fit: cover;

  @media (min-width: 1024px) {
    height: 300px;
  }
  @media (min-width: 600px) and (max-width: 1023px) {
    height: 375px;
  }
  @media (max-width: 600px) {
    height: 300px;
  }
`;

type FilterProps = { backgroundImage: string };
const Filter = styled.div<FilterProps>`
  width: 100%;
  border-radius: ${CornerRadius.md}px;
  overflow: hidden;
  position: relative;

  > * {
    position: relative;
    z-index: 2;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: url(${(props: FilterProps) => props.backgroundImage});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    filter: blur(12.6px);
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background-color: ${(props: ThemeProps<Theme>) =>
      props.theme.name === 'dark' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)'};
    z-index: 1;
  }
`;

export const WorkoutMedia = ({ media }: { media: string }) => {
  return (
    <Container>
      <Filter backgroundImage={media}>
        <StyledImageContainer>
          <StyledImage src={media} />
        </StyledImageContainer>
      </Filter>
    </Container>
  );
};
